function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_845_257)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M25.3136 22.6387C24.928 23.7302 23.3952 24.6332 22.1728 24.8973C21.336 25.0749 20.2448 25.2155 16.568 23.6918C12.4384 21.9809 6.704 15.8865 6.704 11.8309C6.704 9.76624 7.8944 7.36211 9.976 7.36211C10.9776 7.36211 11.1984 7.38164 11.528 8.17227C11.9136 9.10375 12.8544 11.3987 12.9664 11.634C13.4288 12.5991 12.496 13.164 11.8192 14.0043C11.6032 14.2572 11.3584 14.5306 11.632 15.0012C11.904 15.4621 12.8448 16.9954 14.2272 18.2262C16.0128 19.8171 17.4608 20.325 17.9792 20.541C18.3648 20.7011 18.8256 20.6638 19.1072 20.3629C19.464 19.9772 19.9072 19.3372 20.3584 18.7066C20.6768 18.2553 21.0816 18.1989 21.5056 18.359C21.792 18.4582 25.432 20.1487 25.5856 20.4191C25.6992 20.616 25.6992 21.5471 25.3136 22.6387ZM16.0032 0.0449219H15.9952C7.17439 0.0449219 0 7.22148 0 16.0449C0 19.5436 1.12801 22.7895 3.04641 25.4223L1.05281 31.3676L7.20161 29.4027C9.73121 31.0768 12.7504 32.0449 16.0032 32.0449C24.824 32.0449 32 24.8684 32 16.0449C32 7.22148 24.824 0.0449219 16.0032 0.0449219Z",
  fill: "white"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_845_257"
}, /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 32,
  fill: "white",
  transform: "translate(0 0.0449219)"
})));

var SvgWhatsapp = function SvgWhatsapp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 33",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWhatsapp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/whatsapp.95102513.svg";
export { ForwardRef as ReactComponent };